import React, { ForwardedRef } from 'react';

import './InputText.scss';
import cls from 'classnames';

export type InputTextContent = React.InputHTMLAttributes<HTMLInputElement> & {
  label?: string;
  message?: string;
  type: string;
  placeholder: string;
  value: string;
  id: string;
  disabled?: boolean;
};

const InputText = (props: InputTextContent, ref: ForwardedRef<any>) => {
  const { label, className, value, onChange, message, type, placeholder, disabled, id, ...rest } =
    props;

  return (
    <>
      {label && (
        <label htmlFor={id} className="input-label">
          {label}
        </label>
      )}

      <input
        type={type}
        className={cls('text-input', className)}
        id={id}
        placeholder={placeholder}
        onChange={onChange}
        value={value}
        disabled={disabled}
        ref={ref}
        {...rest}
      />
      {message && <p className="helper-text">{message}</p>}
    </>
  );
};

export default React.forwardRef(InputText);
